import _ from 'lodash';
import React from 'react';
import AppLink from '../AppLink/AppLink';

interface IPhoneLinkProps {
  phone?: string;
  extension?: string;
}

export default function PhoneLink({ phone, extension }: IPhoneLinkProps) {
  if (_.isEmpty(phone)) {
    return <span>-</span>;
  }

  const ext = extension ? ` ext. ${extension}` : '';

  return (
    <span>
      <AppLink to={`tel:${phone}`}>{phone}</AppLink>
      {ext && <span>{ext}</span>}
    </span>
  );
}
